import { useLocation } from 'react-router-dom';
import {
  resolveBackLink,
  type BackLinkFallback,
  type ResolvedBackLink,
} from '../utils/backLink';

/**
 * Resolve a back-link label + path from navigation state. Screens supply
 * their own `fallback` so deep-link arrivals without state land on a
 * screen-appropriate path.
 *
 * Example:
 *   const back = useBackLink({
 *     fallback: { label: 'Back to Explore Segments', path: '/explore-segments' },
 *   });
 *   <button onClick={() => navigate(back.path)}>{back.label}</button>
 *
 * Thin wrapper around resolveBackLink(). Use the underlying function
 * directly when you already have the state object (e.g. in a utility or
 * a non-React call site).
 */
export function useBackLink(opts: { fallback: BackLinkFallback }): ResolvedBackLink {
  const location = useLocation();
  return resolveBackLink(location.state, opts.fallback);
}
